<template>
  <a-card title="Неделя" :bordered="false">
    <a-table
      :dataSource="rows"
      :columns="columns"
      :pagination="false"
      rowKey="date"
      size="small"
      :rowClassName="rowClassName"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'meals'">
          <div class="week-meals">
            <span class="week-meal-stat"><strong>З:</strong> {{ mealValue(record, 'BREAKFAST') }}</span>
            <span class="week-meal-stat"><strong>О:</strong> {{ mealValue(record, 'LUNCH') }}</span>
            <span class="week-meal-stat"><strong>П:</strong> {{ mealValue(record, 'SNACK') }}</span>
            <span class="week-meal-stat"><strong>У:</strong> {{ mealValue(record, 'DINNER') }}</span>
          </div>
        </template>

        <template v-else-if="column.key === 'status'">
          <a-tag :color="record.exists ? 'green' : 'default'">
            {{ record.exists ? label(record.status || 'DRAFT') : 'Нет заказа' }}
          </a-tag>
        </template>
      </template>
    </a-table>
  </a-card>
</template>

<script setup>
import { computed } from 'vue'
import dayjs from 'dayjs'
import { label } from '../utils/labels'

const props = defineProps({
  items: { type: Array, default: () => [] },
  selectedDate: { type: String, default: '' },
})

const rows = computed(() => props.items)

const columns = [
  {
    title: 'Дата',
    dataIndex: 'date',
    customRender: ({ text }) => formatDate(text),
  },
  { title: 'З / О / П / У', key: 'meals' },
  { title: 'Статус', key: 'status' }
]

function formatDate(value) {
  if (!value) return ''
  return dayjs(value).format('YYYY-MM-DD, dd')
}

function rowClassName(record) {
  return dayjs(record?.date).isSame(props.selectedDate, 'day') ? 'week-row-selected' : ''
}

function mealValue(record, meal) {
  return Number(record?.meals?.[meal] || 0)
}
</script>

<style scoped>
.week-meals {
  display: grid;
  grid-template-columns: repeat(4, minmax(58px, max-content));
  gap: 12px;
  align-items: center;
}

.week-meal-stat {
  white-space: nowrap;
  text-align: left;
}

:deep(.week-row-selected > td) {
  background: #eaf4ff !important;
}

@media (max-width: 767px) {
  .week-meals {
    grid-template-columns: repeat(2, minmax(58px, max-content));
    gap: 8px 14px;
  }
}
</style>
